import { render, staticRenderFns } from "./MemberDetailUsages.vue?vue&type=template&id=52618781"
import script from "./MemberDetailUsages.vue?vue&type=script&lang=js"
export * from "./MemberDetailUsages.vue?vue&type=script&lang=js"
import style0 from "./MemberDetailUsages.vue?vue&type=style&index=0&id=52618781&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports